import axios from "axios";
import {restApi} from "../../../../constants/api";
export const getProductCount = async () => {
        const response = await restApi("dashbaord/product-count","GET",{});
        return response 
};
export const getOrderCount = async () => {
    const response = await restApi("dashbaord/order-count","GET",{});
    return response 
};
export const getTotalCompletedOrderAmount = async () => {
    const response = await restApi("dashbaord/total-count-granted-quotation","GET",{});
    return response 
};
// export const getOutOfStockCount = async () => {
//     const response = await restApi("dashboard/out-of-stock-count","GET",{});
//     return response 
// };

export const getOrdersPerDay = async (year:any, month:any) => {
    const response = await restApi(`dashbaord/orders-per-day?year=${year}&month=${month}`,"GET",{});
    return response 
};

export const getTotalPricePerDay = async (year:any) => {
    const response = await restApi(`dashbaord/total-count-per-month?year=${year}`,"GET",{});
    return response 
};

export const getPurchase_Order = async () => {
    const response = await restApi("dashbaord/purchase_order","GET",{});
    return response 
};

export const getweek_data = async () => {
    const response = await restApi("dashbaord/week-data","GET",{});
    return response 
};


